var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseV2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "close"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.414 12.0002L17.707 7.70725C18.098 7.31625 18.098 6.68425 17.707 6.29325C17.316 5.90225 16.684 5.90225 16.293 6.29325L12 10.5862L7.70701 6.29325C7.31601 5.90225 6.68401 5.90225 6.29301 6.29325C5.90201 6.68425 5.90201 7.31625 6.29301 7.70725L10.586 12.0002L6.29301 16.2933C5.90201 16.6842 5.90201 17.3162 6.29301 17.7072C6.48801 17.9022 6.74401 18.0002 7.00001 18.0002C7.25601 18.0002 7.51201 17.9022 7.70701 17.7072L12 13.4142L16.293 17.7072C16.488 17.9022 16.744 18.0002 17 18.0002C17.256 18.0002 17.512 17.9022 17.707 17.7072C18.098 17.3162 18.098 16.6842 17.707 16.2933L13.414 12.0002Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20671_23357",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 6,
    width: 14,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.414 12.0002L17.707 7.70725C18.098 7.31625 18.098 6.68425 17.707 6.29325C17.316 5.90225 16.684 5.90225 16.293 6.29325L12 10.5862L7.70701 6.29325C7.31601 5.90225 6.68401 5.90225 6.29301 6.29325C5.90201 6.68425 5.90201 7.31625 6.29301 7.70725L10.586 12.0002L6.29301 16.2933C5.90201 16.6842 5.90201 17.3162 6.29301 17.7072C6.48801 17.9022 6.74401 18.0002 7.00001 18.0002C7.25601 18.0002 7.51201 17.9022 7.70701 17.7072L12 13.4142L16.293 17.7072C16.488 17.9022 16.744 18.0002 17 18.0002C17.256 18.0002 17.512 17.9022 17.707 17.7072C18.098 17.3162 18.098 16.6842 17.707 16.2933L13.414 12.0002Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20671_23357)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseV2);
export default __webpack_public_path__ + "static/media/close-v2.e68bd9551344d8f55f45e1ba03ca421b.svg";
export { ForwardRef as ReactComponent };